import { render, staticRenderFns } from "./LmPeopleTypesListbuilder.vue?vue&type=template&id=63d7b826"
import script from "./LmPeopleTypesListbuilder.vue?vue&type=script&lang=js"
export * from "./LmPeopleTypesListbuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports